/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { VApplication } from "../../../application";
import { toHeaderCase } from "js-convert-case";
import config from "../config/eventDetail.config.json";
import moment from "moment";

export interface IEventDetailMethods extends IPluginMethodMap {
  getEventDetailSync(args: any): any;
}

const lookup = require("country-code-lookup");

export class EventDetailService implements IAgentPlugin {
  readonly methods: IEventDetailMethods;

  constructor() {
    this.methods = {
      getEventDetailSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    console.log(`args in format event detail`, args)
    return {
      title:toHeaderCase(args?.stormName ?? ""),
      subTitle: args?.date ? moment(args?.date).format("LLL"): null,
      listItems: this.getListItems(args),
    };
  }

  private getListItems(res: any) {
    console.log("payments", res?.payments);
    let _temp: any = [];
    _temp = config?.listItems?.map((ele: any) => {
      if (ele?.key === "stormName") {
        return {
          ...ele,
          subTitle: toHeaderCase(res?.stormName ?? "-"),
        };
      }
      if (ele?.key === "box") {
        return {
          ...ele,
          subTitle: toHeaderCase(res?.exposure ?? "-"),
        };
      }
      if (ele?.key === "category") {
        return {
          ...ele,
          subTitle: toHeaderCase(res?.category ?? "-"),
        };
      }
      if (ele?.key === "country") {
        return {
          ...ele,
          // subTitle: res?.country
          //   ? lookup.byIso(`${res?.country}`)?.country
          //   : "-",
          // flag: res?.country,
          subTitle: "USA",
        flag: "us",
        };
      }
      if (ele?.key === "date") {
        return {
          ...ele,
          subTitle: res?.date ? moment(res?.date).format("LLL"): "-",
        };
      }
      if (ele?.key === "payout") {
        return {
          ...ele,
          subTitle:res?.payoutEstimate ?? "-"
        }
      }
      if (ele?.key === "maxWindSpeed") {
        return {
          ...ele,
          subTitle: `${res?.vmax ?? "-"} m/s`,
        };
      }
      if (ele?.key === "minWindSpeed") {
        return {
          ...ele,
          subTitle: `${res?.vmin ?? "-"} m/s`,
        };
      }
    });
    return _temp;
  }

}
